import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { Observable, tap, timer } from 'rxjs';
import { SvgWorkspaceComponent } from '../../../components/svg-workspace/svg-workspace.component';
import { Position } from '../../../models/cutting/cutting-svg.model';
import { PanelBase } from '../../../models/cutting/panel-base.model';

@Component({
  selector: 'csl-fastener-side-select',
  templateUrl: './fastener-side-select.component.html',
})
export class FastenerSideSelectComponent implements OnInit {
  @Input() panel: PanelBase;

  @ViewChild('svgWorkspace', { static: true }) svgWorkspace: SvgWorkspaceComponent;

  @Output() formChanged: EventEmitter<Position> = new EventEmitter();

  render$: Observable<number>;

  ngOnInit(): void {
    /* TODO: Т к раньше это делалось в ngAfterViewChecked, это очень перегружало основной поток и вызывало циклические рендеры,
     * чтобы ничего не поломать и снизить нагрузку добавлен этот костыль,
     * но перерисовку все равно необходимо переделать, чтобы схема перерисовывалась только при реальных изменениях в панели
     */
    this.render$ = timer(0, 1000).pipe(
      tap(() => {
        this.svgWorkspace.draw();
      })
    );
  }

  selectSide(side: Position): void {
    this.formChanged.emit(side);
  }
}
